module.exports = __webpack_public_path__ + "img/correct_part_2_right.647b1512.png";